import React, { useEffect, useRef } from "react";
import "./PapayaGallery.scss"
import heroBackground from "../assets/gallerybg.jpg"
import Carousel from "../components/Carousel/Carousel";
import { useSelector } from "react-redux";
import { sortByOrderAscending } from "../helper/helper";
import CustomVideoPlayer from "../components/CustomVideoPlayer/CustomVideoPlayer";
const PapayaGallery = () => {

    const containerRef = useRef(null);
    const contentRef = useRef(null);
    const pages = useSelector((state) => state.companyData.pages)

    const page = pages.find((page) => page.PageId === "gallery")
    const Components = page?.Components || []

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        const container = containerRef.current;
        const content = contentRef.current;

        if (!container || !content) return;

        let scrollLeft = 0;
        let animationFrame;

        const clone = content.cloneNode(true);
        container.appendChild(clone);

        const animate = () => {
            scrollLeft += 0.5;
            if (scrollLeft >= content.scrollWidth) {
                scrollLeft = 0;// Reset seamlessly
            }
            container.scrollLeft = scrollLeft;
            animationFrame = requestAnimationFrame(animate);
        };

        animationFrame = requestAnimationFrame(animate);

        return () => cancelAnimationFrame(animationFrame);
    }, []);
    const getHeroComponent = (component) => {
        switch (component.ID) {
            case "PapayaGallery-Hero-header":
                return <div className="PapayaGallery-Hero-header">
                    {component?.Props?.text}
                </div>
            case "PapayaGallery-Hero-subheader":
                return <div className="PapayaGallery-Hero-subheader">
                    {component?.Props?.text}
                </div>
            default:
                return <div />
        }

    }
    const getHeroContent = (components, heroBackground) => {
        return (
            <div className="PapayaGallery-Hero"
                style={{
                    backgroundImage: `linear-gradient(rgba(14, 17, 13, 0.7), rgba(14, 17, 13, 0.7)),url(${heroBackground})`
                }}>
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getHeroComponent(component)
                    )
                })}
            </div>
        )
    }
    const getGalleryComponent = (component) => {
        switch (component.ID) {
            case "PapayaGallery-Container-header":
                return <div className="PapayaGallery-Content-header">
                    {component?.Props?.text}
                </div>
            case "PapayaGallery-Container-subheader":
                return <div className="PapayaGallery-Content-subheader">
                    {component?.Props?.text}
                </div>
            case "PapayaGallery-Container-content":
                return <div className="PapayaGallery-Content-content">
                    {component?.Props?.text}
                </div>
            case "PapayaGallery-Container-grid":
                return <Carousel
                    images={component?.Data} />
            default:
                return <div />
        }

    }
    const getGalleryContent = (components) => {
        return (
            <div className="PapayaGallery-Content">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getGalleryComponent(component)
                    )
                })}
            </div>
        )
    }
    const getImagesCarousel = (data) => {
        return (
            <div className="PapayaGallery-ImageCarousel" ref={containerRef}>
                <div className="PapayaGallery-Cont" ref={contentRef}>
                    {data?.map((data, index) => (
                        data?.src.includes(".mp4") ?
                            <CustomVideoPlayer
                                src={data?.src} key={index} /> : <img key={index} src={data?.src} alt={`img-${index}`} className="PapayaGallery-Cont-image" />

                    ))}
                </div>
            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "PapayaGallery-Hero":
                return getHeroContent(component.Components, component?.Props?.bgSrc)
            case "PapayaGallery-Container":
                return getGalleryContent(component.Components)
            case "PapayaGallery-ImageCarousel":
                return getImagesCarousel(component.Data)
            default:
                return <div />
        }

    }
    return (
        <div className="PapayaGallery">
            {sortByOrderAscending(Components).map((component, key) => {
                return (
                    getComponents(component))
            })}
        </div>
    )
}
export default PapayaGallery